import { render, staticRenderFns } from "./timeConfig022Page.vue?vue&type=template&id=7c238b64&"
import script from "./timeConfig022Page.vue?vue&type=script&lang=js&"
export * from "./timeConfig022Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports